import { render, staticRenderFns } from "./AdminArea.vue?vue&type=template&id=f2fed35a&"
import script from "./AdminArea.vue?vue&type=script&lang=js&"
export * from "./AdminArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports